export class PageConstants {
  static planCancelTip = "Your plan will remain active until";
}
